<template>
  <div>
    <div
      v-for="user in take(unreadMandates, 1)" :key="`mandate${user.advisor}`"
      :class="['msg', 'icon', 'warning']"
    >
      <div class="icon">
        <awesomeIcon icon="exclamation-circle" />
      </div>
      <div class="alertText">
        <b>Adviseur {{user.name}} ({{user.email}}) vraagt toegang tot uw account</b><br />
        Door uw adviseur te machtigen verkrijgt deze inzage in de gegevens die u met Doelbeleggen
        deelt ten behoeve van uw beleggingsrekening. De algemene voorwaarden die hier op van
        toepassing zijn heeft u per e-mail van ons ontvangen of kunt u
        <a
          style="text-decoration:underline;color:blue;" target="_blank"
          href="https://www.doelbeleggen.nl/content/uploads/Voorwaarden-online-machtiging-adviseur.pdf"
        >
          hier
        </a>
        nalezen. Wilt u de toegang accepteren of weigeren?<br /><br />
      </div>
      <div style= "float:right">
        <button style="margin-right: 10px" @click="acceptMandate(user.advisor)">
          <awesomeIcon icon="user-plus"/> Accepteren
        </button>
        <button @click="removeMandate(user.advisor)" class="tertiary">
          <awesomeIcon icon="user-slash"/> Weigeren
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { take } from 'lodash-es';

export default {
  name: 'mandateAlerts',
  props: {
    unreadMandates: Array,
  },
  methods: {
    take,
    removeMandate(user) {
      this.$store.state.confirm.toggle({
        text: `Let op: bij 'weigeren' van het mandaat wordt ook de betreffende vragenlijst
        verwijderd.<br><br> Weet u zeker dat u dit mandaat wilt weigeren?`,
        confirmText: 'Weigeren',
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.removeMandate(user, (response) => {
              if (response.status === 200) {
                window.location.reload();
              }
            });
          }
        },
      });
    },
    acceptMandate(user) {
      this.$store.state.confirm.toggle({
        text: 'Lees voor het accepteren de bijbehorende voorwaarden goed door.',
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.acceptMandate(user, (response) => {
              if (response.status === 200) {
                window.location.reload();
              }
            });
          }
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.msg {
  @media #{$mobile} {
    margin-top:35px;
  }
}
</style>
